<template>
    <div class="SoftwareCardIssue CardReaderSubComponent">
        <v-alert
            class="CardReaderSubComponent-alert"
            color="warning"
            variant="tonal"
        >
            <div
                class="CardReaderSubComponent-title"
                v-text="title"
            />
            <span
                class="CardReaderSubComponent-description"
                v-html="$sanitize(getDescription)"
            />
        </v-alert>
        <v-btn
            class="CardReaderSubComponent-button"
            color="primary"
            variant="flat"
            @click="goToSoftware"
        >
            {{ $t('card_reader:detect_card:detect_button_text') }}
        </v-btn>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const emit = defineEmits(['goToSoftware'])

const props = defineProps({
    description: {
        type: String,
        required: true
    },
    supportId: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        required: true
    }
})

const getDescription = computed(() => {
    if (props.supportId) {
        return props.description.replace('%supportId%', props.supportId)
    }

    return props.description
})

function goToSoftware () {
    emit('goToSoftware')
}
</script>
